import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './Components/Header';
import CanonicalRedirect from './Components/CanonicalRedirect';
import MainPage from './Screens/MainPage';
import About from './Screens/about';
import AutoLista from './Screens/AutomoveisLista';
import CarDetailsPage from './Screens/AutomovelDetalhes';
import Contacto from './Screens/Contacto';
import Privacidade from './Screens/PoliticaPrivacidade';
import Termos from './Screens/TermosCondicoes';
import Footer from './Components/footer';
import DemoDisclaimerModal from './Components/DemoDisclaimerModal';

import { CarProvider } from './stores/CarContext';
import { GeneralProvider } from './stores/GeneralContext';
import { ThemeProvider } from './stores/ThemeContext';
import { ModalProvider } from './stores/ModalContext';

function AppContent() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-black">
      <DemoDisclaimerModal />
      <CanonicalRedirect />
      <Header />
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/sobre" element={<About />} />
        <Route path="/automoveis" element={<AutoLista />} />
        <Route path="/automoveis/:id" element={<CarDetailsPage />} />
        <Route path="/contactos" element={<Contacto />} />
        <Route path="/privacidade" element={<Privacidade />} />
        <Route path="/termos" element={<Termos />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <ModalProvider>
          <CarProvider>
            <GeneralProvider>
              <Router>
                <AppContent />
              </Router>
            </GeneralProvider>
          </CarProvider>
        </ModalProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
